<template>
    <ListNormalPage :data="data" v-if="data" />
    <LoadingWrap v-else />
</template>

<script>
import ListNormalPage from '@/views/common/ListNormalPage.vue';
import { getIRLetterList } from '@/api';
import LoadingWrap from '../LoadingWrap.vue';

export default {
    components: {
        ListNormalPage,
        LoadingWrap,
    },
    data() {
        return {
            data: null,
        };
    },
    async mounted() {
        await this.getList();
    },
    watch: {
        async $route() {
            await this.getList();
        },
    },
    methods: {
        async getList() {
            try {
                const { paging: data } = await getIRLetterList(this.$route.query);

                this.data = data;
            } catch (err) {
                if (!this.data) this.data = null;
            }
        },
    },
};
</script>
